import { centerable as s } from "../decorators/centerable.js";
import { uploadable as u } from "../decorators/uploadable.js";
import { BLOCK_CLASSES as l, ALIGN_CLASSES as d } from "../../constants.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const b = s(
  u({
    inline: !1,
    draggable: !0,
    attrs: {
      type: { default: "image" },
      src: {},
      linkUrl: { default: "" },
      width: { default: "" },
      displayWidth: { default: "" },
      height: { default: "" },
      text: { default: "" }
    },
    group: "block",
    parseDOM: [
      {
        tag: ".intercom-interblocks-image",
        priority: 60,
        getAttrs(t) {
          let e = t.querySelector("img");
          return {
            src: e.getAttribute("src"),
            text: e.getAttribute("alt")
          };
        }
      },
      {
        tag: "img[src]",
        getAttrs(t) {
          return {
            src: t.getAttribute("src"),
            linkUrl: t.getAttribute("data-link-url"),
            width: t.getAttribute("data-width") || t.style.width.replace("px", ""),
            height: t.getAttribute("data-height"),
            text: t.getAttribute("alt")
          };
        }
      }
    ],
    toDOM(t) {
      let { src: e, width: i, displayWidth: r, height: g, text: a } = t.attrs;
      return r = r || i, [
        "div",
        {
          class: `${l.blockContainer} ${l.image}`
        },
        [
          "img",
          {
            src: e,
            ...a && { alt: a },
            class: `${d[t.attrs.alignment]}`,
            style: `display: block; width: ${r}px;`,
            "data-link-url": t.attrs.linkUrl,
            "data-height": g,
            "data-width": i
          }
        ]
      ];
    }
  })
);
export {
  b as imageSpec
};
